import React, { useEffect, useMemo } from 'react';
import { Row, Col } from 'reactstrap';
import { useNavigate, useParams } from 'react-router-dom';
import TextInput from '../../custom/components/Text-Input/TextInput';
import CheckboxInput from '../../custom/components/CheckBox-Input/CheckboxInput.js';
import CustomForm from '../../custom/Forms/CustomForm';
import { getRecords, postData, saveRecords } from '../../services/api.service.js';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import useCreateForm from '../../custom/Utils/UseCreateFormUtils.js';
import { createPageData, intialformData } from './VendorUserFile.js';
import { validate } from '../../custom/validations/Validate.js';
import { fetchVendorActionLogDetails } from '../../custom/Utils/vendorLogsUtils.js';

const VendorUserCreate = () => {
    const navigate = useNavigate();
    let { id } = useParams();
    const {
        payload,
        navigatePage,
        headerName,
        validationType,
    } = createPageData();
    const initialPayload = useMemo(() => payload, []);
    const {
        formData,
        onInputChange,
        formErrors,
        setLoadingData,
        loadingData,
        setFormErrors,
    } = useCreateForm(
        id,
        initialPayload,
        intialformData(),
        validationType,
    );
    
    const [originalEmail, setOriginalEmail] = React.useState('');
    
    useEffect(() => {
        if (id && formData?.inputData?.email_id_68) {
            setOriginalEmail(formData.inputData.email_id_68);
        }
    }, [id, formData?.inputData?.email_id_68]);
    const handleSubmit = async (e) => {
        e.preventDefault();
        const errors = validate(validationType, formData?.inputData, id);
        if (Object.keys(errors).length > 0) {
            setFormErrors(errors);
            return;
        }
        setLoadingData(true);
        const updatedInputData = {
            ...formData.inputData,
            username_127: formData?.inputData?.email_id_68, // Assign email as username
        };
        const payload = {
            id: id,
            modelName: initialPayload?.modelName,
            inputData: updatedInputData,
        };

        const responseData = await saveRecords("/common/saveRecords", payload);
        if (responseData && responseData.code == 1) {
            await fetchVendorActionLogDetails(
                id ? 'Update - Vendor User' : 'Submit - Vendor User'
            );
            //toast.success(responseData.message);
            toast.success(id ? "Vendor User Updated Successfully." : "Vendor User Created Successfully.");
            navigate(navigatePage?.back);
        } else {
            if (responseData?.message?.toLowerCase().includes('e-mail')) {
                const enteredEmail = formData?.inputData?.email_id_68 || '';

                // If it's a new record OR the user has changed the email
                if (!id || enteredEmail !== originalEmail) {
                    const customEmailError = `Vendor User "${enteredEmail}" has already been taken.`;

                    setFormErrors((prev) => ({
                        ...prev,
                        email_id_68: customEmailError,
                    }));
                } else {
                    // If it's the same email and still triggers backend error (just fallback)
                    toast.error(responseData.message);
                }
            }
        }
        setLoadingData(false);
    };
    return (
        <CustomForm
            title={`${id ? 'Update' : 'Create'} ${headerName}`}
            loadingData={loadingData}
            onFormSubmit={handleSubmit}
            handleBackClick={() => navigate(navigatePage?.back)}
            id={id}
        >
            <Row className='mt-2'>
                <Col md='4' className='mt-3'>
                    <TextInput
                        label='E-Mail (Consider as Username)'
                        name='email_id_68'
                        value={formData?.inputData?.email_id_68}
                        onChange={onInputChange}
                        placeholder='Please enter your e-mail (Consider as Username)'
                        parentClassName=''
                        inputClassName='form-control'
                        labelClassName='form-label table-header-bold-extra'
                        parentStyle={{}}
                        inputStyle={{}}
                        labelStyle={{}}
                        maxLength
                        minLength
                        readOnly={false}
                        disabled={false}
                        required={true}
                        spellcheck={false}
                        size
                        pattern='[A-Za-z0-9]+'
                        autocomplete={'off'}
                        customError={formErrors?.email_id_68}
                    />
                </Col>

                <Col md='4' className='mt-3'>
                    <TextInput
                        label='Mobile Number'
                        name='mobile_no_67'
                        value={formData?.inputData?.mobile_no_67}
                        onChange={onInputChange}
                        placeholder='Please enter your mobile number'
                        parentClassName=''
                        inputClassName='form-control'
                        labelClassName='form-label table-header-bold-extra'
                        parentStyle={{}}
                        inputStyle={{}}
                        labelStyle={{}}
                        maxLength
                        minLength
                        readOnly={false}
                        disabled={false}
                        required={false}
                        spellcheck={false}
                        size
                        pattern='[A-Za-z0-9]+'
                        autocomplete={'off'}
                        customError={formErrors?.mobile_no_67}
                    />
                </Col>

                <Col md='4' className='mt-3'>
                    <TextInput
                        label='Name'
                        name='name_66'
                        value={formData?.inputData?.name_66}
                        onChange={onInputChange}
                        placeholder='Please enter your name'
                        parentClassName=''
                        inputClassName='form-control'
                        labelClassName='form-label table-header-bold-extra'
                        parentStyle={{}}
                        inputStyle={{}}
                        labelStyle={{}}
                        maxLength
                        minLength
                        readOnly={false}
                        disabled={false}
                        required={true}
                        spellcheck={false}
                        size
                        pattern='[A-Za-z0-9]+'
                        autocomplete={'off'}
                        customError={formErrors?.name_66}
                    />
                </Col>
            </Row>

            <Row className='mt-3'>
                <Col md='4' className='mt-3'>
                    <TextInput
                        label='Password'
                        name='password_69'
                        value={formData?.inputData?.password_69}
                        onChange={onInputChange}
                        placeholder='Please enter your password'
                        parentClassName=''
                        inputClassName='form-control'
                        labelClassName='form-label table-header-bold-extra'
                        parentStyle={{}}
                        inputStyle={{}}
                        labelStyle={{}}
                        maxLength
                        minLength
                        readOnly={false}
                        disabled={false}
                        required={id ? false : true}
                        spellcheck={false}
                        size
                        pattern='[A-Za-z0-9]+'
                        autocomplete={'off'}
                        customError={formErrors?.password_69}
                    />
                </Col>

                <Col lg='4' className='mt-5'>
                    <CheckboxInput
                        label='Is Active'
                        name='is_active_157'
                        value={formData?.inputData?.is_active_157}
                        checked={formData?.inputData?.is_active_157}
                        handleTextChange={onInputChange}
                        parentClassName='form-check'
                        checkBoxClassName='form-check-input'
                        labelClassName='form-check-label table-header-bold-extra'
                        parentStyle={{}}
                        checkboxStyle={{}}
                        labelStyle={{}}
                        disabled={false}
                        required={false}
                        customError={formErrors.is_active_157}
                    />
                </Col>
            </Row>
        </CustomForm>
    );
};
export default VendorUserCreate;
